import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    quote: 'Robinson Engineering delivered beyond our expectations.',
    author: 'Alex, CTO'
  },
  {
    quote: 'Their pragmatic approach to AI saved us months of work.',
    author: 'Jamie, Operations Lead'
  },
  {
    quote: 'The team provided great insight and quick iterations.',
    author: 'Morgan, Project Manager'
  }
];

export default function Testimonials() {
  const settings = {
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 500
  };

  return (
    <Container sx={{ py: 8, backgroundColor: 'background.paper' }}>
      <Typography
        variant="h2"
        component="h2"
        align="center"
        color="secondary.main"
        gutterBottom
      >
        Testimonials
      </Typography>
      <Slider {...settings}>
        {testimonials.map((t) => (
          <Box key={t.author} sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="body1" sx={{ fontStyle: 'italic' }} gutterBottom>
              "{t.quote}"
            </Typography>
            <Typography variant="subtitle2">- {t.author}</Typography>
          </Box>
        ))}
      </Slider>
    </Container>
  );
}
